import { Controller } from '@hotwired/stimulus';
import axios from "axios";

export default class extends Controller {
    static values = {
        clubId: Number,
    }
    connect() {
        this.workoutsContainer = this.element.querySelector('#workoutsContainer');
        this.intensitySelector = this.element.querySelector('#intensitySelector');
        this.adminAjaxUrl = '/wp-admin/admin-ajax.php';
        this.loader = this.element.querySelector('.loader');
        this.currentTimeout = null;
        //this.displayedPosts = this.element.dataset.displayedPosts;

        this.intensitySelector.addEventListener('change', ()=>{
            this.loadPosts(500, this.intensitySelector.value, this.clubIdValue);
            console.log(this.intensitySelector.value, this.clubIdValue);
        })
    }



    loadPosts(delay, intensity, club) {
        clearTimeout(this.currentTimeout);
        this.currentTimeout = setTimeout(() => {
            this.workoutsContainer.innerHTML = '';
            this.loader.classList.remove('d-none');

            let formData = new FormData;
            formData.append('action', 'workouts_load_posts');
            formData.append('intensity', intensity);
            formData.append('club', club);

            axios.post(this.adminAjaxUrl, formData).then((response)=>{
                if (response.data.html) {
                    this.loader.classList.add('d-none');
                    this.workoutsContainer.innerHTML += response.data.html;
                }
            });
        }, delay);
    }
}
